import React from 'react';

const Programs: React.FC = () => {
  return (
    <div className="min-h-screen py-16">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12 text-pakistan-green">
          Our Programs
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white rounded-lg p-6 shadow-lg">
            <h3 className="text-2xl font-bold mb-4">🏭 Manufacturing</h3>
            <p className="text-gray-600">Mobile accessories, textiles, and food processing factories creating sustainable jobs.</p>
          </div>
          <div className="bg-white rounded-lg p-6 shadow-lg">
            <h3 className="text-2xl font-bold mb-4">🎓 Education</h3>
            <p className="text-gray-600">Free education and skill development programs for all ages.</p>
          </div>
          <div className="bg-white rounded-lg p-6 shadow-lg">
            <h3 className="text-2xl font-bold mb-4">🏥 Healthcare</h3>
            <p className="text-gray-600">Community health clinics and medical outreach programs.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Programs;
